export const emptyStateTypes = {
  product: '/img/error/empty-product.svg',
  box: '/img/error/empty-box.svg',
  cart: '/img/error/empty-cart.svg',
  review: '/img/error/empty-review.svg',
  voucher: '/img/error/empty-voucher.svg',
  flashSale: '/img/error/empty-flash-sale.svg',
  eventSale: '/img/error/empty-sale.svg',
  clearanceSale: '/img/error/empty-clearance-sale.svg',
  presale: '/img/error/empty-pre-sale.svg',
  bankAccount: '/img/error/empty-bank-account.svg',
  affiliateProduct: '/img/error/empty-affiliate-product.svg',
  affiliateCommission: '/img/error/empty-commission.svg',
  pageNotFound: '/img/error/404.svg'
}
